import { IconButton } from "@mui/material"
import { BlockClicks } from "lib/@components/block-clicks"
import Iconify from "minimals-template/components/Iconify"
import { useParams } from "react-router"
import { navigateScheduleEditor } from "../utilities/project-navigation"
import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { DraftStatus } from "authoring/lib/enum/draft-status.mjs"
import { IfTooltip } from "lib/if-tooltip"
import { isLockedToLegacy } from "authoring/lib/enum/project-phase.mjs"
import { Secure } from "lib/authorization/secure"
import { Frag } from "lib/@components/slot/frag"
import { AUTHORING_EDIT_SCHEDULES_DEMAND } from "authoring/lib/constants/authoring-permissions.mjs"

export function EditScheduleButton() {
    const { projectId } = useParams()
    const { targetId: scheduleId, status, target } = useBoundContext()
    const sentToLegacy = isLockedToLegacy(target?.phase)

    let disabledMessage = ""
    const disabled = status === DraftStatus.SUBMITTED || status === DraftStatus.APPROVED || !!sentToLegacy
    if (status === DraftStatus.SUBMITTED) disabledMessage = "A draft cannot be edited after it was submitted for review"
    if (status === DraftStatus.APPROVED) disabledMessage = "A draft cannot be edited after the review was approved"
    if (sentToLegacy) disabledMessage = "A draft cannot be edited after it was sent to legacy"

    return (
        <Secure demand={AUTHORING_EDIT_SCHEDULES_DEMAND} fallback={<Frag />}>
            <IfTooltip condition={disabled} title={disabledMessage}>
                <BlockClicks>
                    <IconButton
                        aria-label="Edit schedule"
                        sx={{ color: "primary.main" }}
                        data-cy="edit-schedule-button"
                        onClick={() => navigateScheduleEditor({ projectId, scheduleId })}
                        disabled={disabled}
                    >
                        <Iconify icon="material-symbols:edit" />
                    </IconButton>
                </BlockClicks>
            </IfTooltip>
        </Secure>
    )
}
